//@ts-ignore
import { useContext, useEffect, useRef, useState } from "react";
import client from "../../../contentfulClient";
import { MainContext } from "../../../MainContext";

export const Heading = () => {
    const { heading, headingRef, openModal, staticTexts, lang, staticTexts: { learnMoreButton: learnMoreButton }, staticTexts: { contactUsButton: contactUsButton }, } = useContext(MainContext);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.5,
            }
        );

        if (headingRef.current) {
            observer.observe(headingRef.current);
        }

        return () => {
            if (headingRef.current) {
                observer.unobserve(headingRef.current);
            }
        };
    }, []);

    return (
        <div
            className={`heading ${isVisible ? "visible" : ""}`}
            style={{
                backgroundImage: `url(${heading.background})`,
            }}
            ref={headingRef}
        >
            <div className="image-information">
                <div className="texts">
                    <div className="img" style={{backgroundImage:`url(${heading.lilit})`}}></div>
                    {/* <img src={`${heading.lilit}`} alt="" /> */}
                    <div className="right">
                        <div className="wrapper">
                            <p className="typography" style={{fontSize:["Ru", "Am"].includes(lang) ? "30px" : ""}}>{heading.title}</p>
                            <p className="typography_small">{heading.subTitle}</p>

                            <div className="buttons">
                                <div className="btn-gray" onClick={() => openModal({ ...heading, image:heading.lilit, text:staticTexts.aboutUs.text })}>
                                    {learnMoreButton.text}
                                </div> 
                                <div className="btn-blue" onClick={() => openModal({type: "contact"})}>{contactUsButton.text}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
